<template lang="html">
    <!-- Use the AppTitle component -->
    <AppTitle>
        <template #title>ห้องน้ำ</template>
        <template #subtitle>Wanon Niwat Hospital [WEBPORTAL WNH]</template>
        <template #breadcrumb>Dashboard</template>
    </AppTitle>

    <div class="row">
        <div class="col-md-12">
            <div class="tile">
                <Overlay :showOverlay="!items.length" />
                <!-- <div class="tile-title-w-btn">
                    <h3 class="title">ห้องน้ำ ทั้งหมด</h3>
                    <p>
                        <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                            <i class="bi bi-plus-square me-2"></i> Add Item
                        </a>
                    </p>
                </div> -->

                <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                    <h3 class="title">ห้องน้ำ ทั้งหมด</h3>
                    <div class="d-flex align-items-center gap-2">
                        <select v-model="filterKey" class="form-select" style="width: auto;">
                            <option value="code">Code</option>
                            <option value="name">Name</option>
                            <option value="details">Details</option>
                            <option value="location">Location</option>
                            <option value="group.name">Department</option>
                        </select>

                        <!-- Show input if filterKey is not 'group.name' -->
                        <input v-if="filterKey !== 'group.name'" type="text" v-model="filterText"
                            placeholder="Search..." class="form-control" style="width: 200px;" />

                        <!-- Show department dropdown if filterKey is 'group.name' -->
                        <select v-else class="form-select" v-model="selectedGroupId" style="width: 200px;">
                            <option value="">All Departments</option>
                            <option v-for="(item, index) in groups" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>

                        <p>
                            <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                <i class="bi bi-plus-square me-2"></i> Add Item
                            </a>
                        </p>
                    </div>
                </div>

                <div class="tile-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Details</th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Department</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in filteredItems" :key="item.id">
                                    <th scope="row">{{ index + 1 }}</th>
                                    <td>{{ item.code }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.details }}</td>
                                    <td>{{ item.location }}</td>
                                    <td>{{ item.group?.name }}</td>
                                    <td>
                                        <div class="btn-group btn-group-sm" role="group"
                                            aria-label="Basic mixed styles example">
                                            <button type="button" class="btn btn-warning" @click="openEditModal(item)">
                                                <i class="bi bi-pencil"></i> Edit
                                            </button>
                                            <button type="button" class="btn btn-danger" @click="handleDelete(item.id)">
                                                <i class="bi bi-trash"></i> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="modalLabel">
                                        {{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}
                                    </h5>
                                    <button type="button" class="btn-close" aria-label="Close"
                                        @click="hideModal"></button>
                                </div>
                                <form @submit.prevent="handleSubmit(editingItem)">
                                    <div class="modal-body">
                                        <!-- Download QR code button -->
                                        <div v-if="modalMode != 'add'" class="text-center">
                                            <button type="button" @click="downloadQRCode"
                                                class="btn btn-success">Download
                                                QR
                                                Code</button>
                                        </div>

                                        <!-- QRCode generation -->
                                        <div v-if="editingItem.code" ref="qrCodeContainer" class="text-center p-4">
                                            <div class="text-center mb-3">
                                                <qrcode-vue :value="`${url}/${editingItem.code}`"
                                                    size="128"></qrcode-vue>
                                            </div>
                                            <p class="mb-0">
                                                {{ editingItem.name }} [{{ editingItem.code }}] {{ editingItem.location
                                                }}
                                            </p>
                                            <p class="mb-0">
                                                {{ editingItem.group?.name }}
                                            </p>
                                            <!-- <p v-clipboard:copy="`${url}/${editingItem.code}`">
                                                {{ url }}/{{ editingItem.code }}
                                            </p> -->
                                        </div>

                                        <div class="mb-3">
                                            <label for="name" class="form-label">Name</label>
                                            <input type="text" id="name" class="form-control" v-model="editingItem.name"
                                                required />
                                        </div>
                                        <!-- Details Field -->
                                        <div class="mb-3">
                                            <label for="details" class="form-label">Details</label>
                                            <textarea id="details" class="form-control"
                                                v-model="editingItem.details"></textarea>
                                        </div>
                                        <div class="mb-3">
                                            <label for="location" class="form-label">Location</label>
                                            <input type="text" id="location" class="form-control"
                                                v-model="editingItem.location" />
                                        </div>
                                        <div class="mb-3">
                                            <label for="group" class="form-label">Department</label>
                                            <select id="group" class="form-select" v-model="editingItem.group_id"
                                                required>
                                                <option v-for="dept in groups" :key="dept.id" :value="dept.id">
                                                    {{ dept.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            @click="hideModal">Close</button>
                                        <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <span class="spinner-border spinner-border-sm me-1" role="status"
                                                    aria-hidden="true"></span>
                                                Saving...
                                            </span>
                                            <span v-else>Save changes</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Modal } from 'bootstrap';
import { reactive, nextTick, ref, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import {
    showErrorAlert,
    showCreateAlert,
    showUpdateAlert,
    showDeleteAlert,
    showConfirm
} from '@/utils/sweetalert2-utils';
import Overlay from '@/components/Overlay.vue';
import QrcodeVue from 'qrcode.vue'
import html2canvas from 'html2canvas';
import AppTitle from '@/layouts/AppTitle.vue';

const qrCodeContainer = ref(null);
const url = ref(`${process.env.VUE_APP_URL_BASE}/view-restroom`);
const items = ref([]);
const modalMode = ref('add');
const editingItem = reactive({
    code: '',
    name: '',
    details: '',
    location: '',
});
const groups = ref([]);
const selectedGroupId = ref('');

const filterKey = ref('code');
const filterText = ref('');

import { computed } from 'vue';

const filteredItems = computed(() => {
    // if (!filterText.value.trim()) return items.value;

    // return items.value.filter(item => {
    //     const value = filterKey.value === 'group.name'
    //         ? item.group?.name || ''
    //         : item[filterKey.value] || '';

    //     return value.toLowerCase().includes(filterText.value.toLowerCase());
    // });
    // return items.value.filter(item => {
    //     // Text filter
    //     const fieldValue = filterKey.value === 'group.name'
    //         ? item.group?.name || ''
    //         : item[filterKey.value] || '';

    //     const matchesText = fieldValue.toLowerCase().includes(filterText.value.toLowerCase());

    //     // Department filter
    //     const matchesGroup = selectedGroupId.value
    //         ? item.group_id === selectedGroupId.value
    //         : true;

    //     return matchesText && matchesGroup;
    // });

    return items.value.filter(item => {
        if (filterKey.value === 'group.name') {
            return selectedGroupId.value
                ? item.group_id === selectedGroupId.value
                : true;
        } else {
            const value = item[filterKey.value] || '';
            return value.toLowerCase().includes(filterText.value.toLowerCase());
        }
    });
});

const fetchData = async () => {
    try {
        const [restRoomRes, groupsRes] = await Promise.all([
            axiosInstance.get('/restroom'),
            axiosInstance.get('/group'),
        ]);

        items.value = restRoomRes.data;
        groups.value = groupsRes.data;
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const handleDelete = async (id) => {
    const result = await showConfirm();
    if (result.isConfirmed) {
        try {
            await axiosInstance.delete(`/restroom/${id}`);
            fetchData();
            showDeleteAlert();
        } catch (error) {
            showErrorAlert('เกิดข้อผิดพลาดในการลบรายการ');
        }
    }
};

const isSubmitting = ref(false);

const handleSubmit = async (updatedItem) => {
    isSubmitting.value = true;

    try {
        if (modalMode.value === 'edit') {
            await axiosInstance.put(`/restroom/${updatedItem.id}`, updatedItem);
            showUpdateAlert();
        } else {
            await axiosInstance.post('/restroom', updatedItem);
            showCreateAlert();
        }
        fetchData();
        hideModal();
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกรายการ');
    } finally {
        isSubmitting.value = false;
    }
};

const showModal = () => {
    nextTick(() => {
        const modalElement = document.getElementById('myModal');
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }
    });
};

const hideModal = () => {
    const modalElement = document.getElementById('myModal');
    const modal = Modal.getInstance(modalElement);
    if (modal) modal.hide();
};

const openAddModal = () => {
    Object.assign(editingItem, { id: null, code: '', name: 'ห้องน้ำ', location: '' });
    modalMode.value = 'add';
    showModal();
};

const openEditModal = (item) => {
    Object.assign(editingItem, item);
    modalMode.value = 'edit';
    showModal();
};

const downloadQRCode = () => {
    const qrCodeElement = qrCodeContainer.value; // Access the qrCodeContainer ref
    if (qrCodeElement) {
        // Use html2canvas to capture the QR code as a canvas
        html2canvas(qrCodeElement).then((canvas) => {
            const imageUrl = canvas.toDataURL('image/png'); // Convert canvas to PNG image URL
            const link = document.createElement('a'); // Create a temporary link element
            link.href = imageUrl; // Set the download URL
            link.download = `${editingItem.code}_qr_code.png`; // Set the default download file name
            link.click(); // Trigger the download
        });
    }
};

onMounted(fetchData);

</script>
